import { isRedirectablePath } from '@brightdrop/auth-client/msal';

export const buildRedirectPathQuery = (location?: Partial<Location>) => {
  const search = new URLSearchParams();
  if (location?.pathname && isRedirectablePath(location.pathname)) {
    search.set('redirectPath', `${location.pathname}${location.search ?? ''}`);
  }
  return search;
};
